<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import UserPersonalityTraitsDataTable from "@/pages/Insights/ReportsDetailPage/components/UserPersonalityTraitsDataTable.vue";
import BaseResultsReport from "@/pages/Insights/ReportsDetailPage/components/BaseResultsReport.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "User Personality Traits", to: null }
]);

</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="User Personality Traits"
      description="Explore user Personality Trait results"
    />

    <BaseResultsReport
      data-endpoint="big5-results"
      metric-endpoint="users-completed-big5-ratio">
      <template #report-table="{ tableData }">
        <user-personality-traits-data-table :loading-data="false" :report-data="tableData" class="borderless"/>
      </template>
    </BaseResultsReport>

  </authenticated-layout>
</template>

<style scoped>

</style>
